export default "__VITE_ASSET__guVH3WTB__"